import { create } from 'zustand';
import { 
  get_customers, 
  get_customer_for_link, 
  post_customer, 
  update_customer, 
  delete_customer 
} from '../utils/apis/customers';

export const useCustomer = create((set, get) => ({
  customers: [],
  loading: false,
  error: null,

  getCustomersList: async () => {
    set({ loading: true });
    try {
      const result = await get_customers();
      set({ customers: result || [], loading: false });
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },

  getCustomersForLink: async () => {
    set({ loading: true });
    try {
      const result = await get_customer_for_link();
      set({ customers: result || [], loading: false });
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },

  postNewCustomer: async (data) => {
    set({ loading: true });
    try {
      const res = await post_customer(data);
      if (res && res.inserted_id) {
        await get().getCustomersList();
      }
      set({ loading: false });
      return res;
    } catch (error) {
      set({ error: error.message, loading: false });
      return null;
    }
  },

  updateCustomer: async (data) => {
    set({ loading: true });
    try {
      const res = await update_customer(data);
      await get().getCustomersList();
      set({ loading: false });
      return res;
    } catch (error) {
      set({ error: error.message, loading: false });
      return null;
    }
  },

  deleteCustomer: async (data) => {
    set({ loading: true });
    try {
      await delete_customer(data);
      await get().getCustomersList();
      set({ loading: false });
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },
}));
